import { useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { MapContext } from '@react-google-maps/api';

const CustomControl = ({ map: mapProp, position, className, children }) => {
    const contextMap = useContext(MapContext);
    const map = mapProp ?? contextMap;

    const controlDivRef = useRef(null);

    if (!controlDivRef.current) {
        controlDivRef.current = document.createElement('div');
        if (className) {
            controlDivRef.current.classList.add(className);
        }
    }

    useEffect(() => {
        const controlDiv = controlDivRef.current;

        if (map && map.controls && map.controls[position] && controlDiv) {
            map.controls[position].push(controlDiv);

            return () => {
                const controls = map.controls[position];
                const array = controls?.getArray();
                if (controls && array) {
                    const index = array.indexOf(controlDiv);
                    if (index !== -1) {
                        controls.removeAt(index);
                    }
                }
            };
        }
    }, [map, position]);

    return createPortal(children, controlDivRef.current);
};

CustomControl.propTypes = {
    map: PropTypes.object,
    position: PropTypes.number.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default CustomControl;
